var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-next",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.9 35.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,17.9L0.8,32.2c-1,1-1,2.1-0.3,2.9c0.8,0.8,2.1,0.9,3,0.1 c0,0,0.1-0.1,0.1-0.1l15.5-15.4c1-1,1-2.5,0.1-3.6L3.7,0.6c-0.9-0.7-2.1-0.7-3-0.1c-0.8,0.8-0.9,2.1-0.1,2.9c0,0,0,0,0,0L15.4,17.9z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.8f361e13bc8df3e9f52673834cd40280.svg";
export { ForwardRef as ReactComponent };